export default "__VITE_ASSET__BxufB4oL__"